import axios from "../../services/interceptor";

export const getPostUnauthenticated = async (params) => {
  const res = await axios.get(`/posts/unauth/${params.postId}`);
  return res.data;
};
